import {
    apiRequest,
    riwayatangkakreditList,
    riwayatangkakreditListAdmin,
    riwayatangkakreditActive,
    riwayatangkakreditInactive
} from "../../../../../../services/adapters/kepegawaian/riwayatangkakreditService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", riwayatangkakreditList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchRowTableAdmin = async (query, cancelToken) => {
        return await apiRequest("get", riwayatangkakreditListAdmin, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", riwayatangkakreditActive, {
            body: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", riwayatangkakreditInactive, {
            body: query
        }, true)
    }
}

export default DataTableRepository